<div id="offerJuncture" class="container">
  <div class="row">
    @if (!this.FlagService.flagServiceObject[2]['familyJunctureFlag']) {
      <div class="col-12 p-0">
        <div class="component-header __indicator">
          <h3 class="label m-0">{{ 'junctures.offer.header' | translate }}</h3>
        </div>
        @if (!(DataService.connectionLinkType === 'KOMPAKT_PARTNERI' || DataService.connectionLinkType === 'KOMPAKT_HOZZATARTOZOI' )) {
          <span class="info offer-info"
            innerHTML="{{ 'junctures.offer.info' | translate }}">
          </span>
        }
      </div>
    }

    <div id="offerAccordion" class="col-12 p-0 accordion">

      @for (option of offerChoicesArray; track option; let i = $index) {
        <div class="accordion-item offers" [ngClass]="{'active': option.active}">
          <h2 class="accordion-header" id="heading-{{i}}">
            <button class="accordion-button collapsed" [ngClass]="{'grey-collapsed feedback-module': option.active}" type="button" data-bs-toggle="collapse" aria-expanded="false" [attr.data-bs-target]="'#collapse' + option.contractGroupId" [attr.aria-controls]="'collapse' + option.contractGroupId">
              @if (DataService.isKompakt()) {
                <img [attr.src]="getKompaktGroupPix(option.contractGroupId)" class="kompakt" alt="offer illustration" title="offer illustration">
              }
              @if (!DataService.isKompakt()) {
                <img [attr.src]="getContractGroupIcon(i)" alt="offer illustration" title="offer illustration">
              }
              <div class="text">
                <span class="label">{{option.displayName}}</span>
                <span class="detail">{{option.displaySubName}}</span>
                <span class="price">{{this.formatCurrency(option.insuranceFee.annualFee)}} {{ 'common.huf' | translate }} <span style="font-size: 80%; display: contents;">{{ 'junctures.offer.year' | translate }}</span></span>
              </div>
            </button>
          </h2>
          <div id="collapse{{option.contractGroupId}}" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading-' + i" data-bs-parent="#offerAccordion">
            <div class="accordion-body p-0">
              <div class="accordion first-level" id="firstLevelAccordion-{{i}}">
                @for (firstLevel of option.first_level_risks; track firstLevel; let j = $index) {
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="firstLevelHeading-{{j}}">
                      <button class="accordion-button collapsed px-3 pt-2 pb-2" [ngClass]="{'no-pointer': !firstLevel.second_level_risk}" type="button" data-bs-toggle="collapse" aria-expanded="false" [attr.data-bs-target]="'#firstLevelCollapse-' + j" [attr.aria-controls]="'firstLevelCollapse-' + j">
                        @if (isKompaktIcon(firstLevel.riskDisplayIconName)) {
                          <img [src]="getIcon(firstLevel.riskDisplayIconName)">
                        } @else {
                          <svg viewBox="0 0 40 40">
                            <use [attr.xlink:href]="getIcon(firstLevel.riskDisplayIconName)"></use>
                          </svg>
                        }
                        <div class="text">
                          <span class="label text-uppercase">{{firstLevel.riskDisplayName}}</span>
                          @if (firstLevel.riskLimit) {
                            <span class="detail m-0">{{ (DataService.isKompakt() ? 'junctures.offer.riskLimit.kompakt' : 'junctures.offer.riskLimit.notKompakt') | translate }}: {{firstLevel.riskLimit}}</span>
                          }
                          @if (firstLevel.riskExtraInfo) {
                            <span class="detail m-0">{{ 'junctures.offer.riskExtraInfo' | translate }}: {{firstLevel.riskExtraInfo}}</span>
                          }
                        </div>
                      </button>
                    </h2>
                    <div class="icons-container">
                      @if (firstLevel.riskDescription) {
                        <a class="info first me-2" (click)="openInfo2(i, j)">
                          <fa-icon id="firstLevelIcon-{{j}}" class="faInfoCircle"
                          [ngClass]="{'active': expanded[i + 1][j + 1][0]}" [icon]="faInfoCircle"></fa-icon>
                        </a>
                      }
                      @if (firstLevel.second_level_risk) {
                        <fa-icon class="faChevronCircleDown collapsed" [icon]="faChevronCircleDown" data-bs-toggle="collapse" aria-expanded="false" [attr.data-bs-target]="'#firstLevelCollapse-' + j" [attr.aria-controls]="'firstLevelCollapse-' + j"></fa-icon>
                      }
                    </div>
                    @if (firstLevel.riskDescription) {
                      <div class="info-content px-3" [ngClass]="{'expand': expanded[i + 1][j + 1][0]}"
                        >
                        <p class="m-0 pt-3 pb-3" [innerHTML]="firstLevel.riskDescription"></p>
                      </div>
                    }
                    <div id="firstLevelCollapse-{{j}}" class="accordion-collapse collapse" [attr.aria-labelledby]="'firstLevelHeading-' + j" [attr.data-bs-parent]="'#firstLevelAccordion-' + i">
                      <div class="accordion-body">
                        @if (firstLevel.second_level_risk) {
                          @for (secondLevel of firstLevel.second_level_risk; track secondLevel; let k = $index) {
                            <div class="second-level">
                              <svg viewBox="0 0 40 40">
                                <use [attr.xlink:href]="getIcon(secondLevel.riskDisplayIconName)"></use>
                              </svg>
                              <div class="text">
                                <span class="label text-uppercase">{{secondLevel.riskDisplayName}}</span>
                                @if (secondLevel.riskLimit) {
                                  <span class="detail m-0">{{ (DataService.isKompakt() ? 'junctures.offer.riskLimit.kompakt' : 'junctures.offer.riskLimit.notKompakt') | translate }}: {{secondLevel.riskLimit}}</span>
                                }
                              </div>
                              @if (secondLevel.riskDescription) {
                                <div class="icons-container">
                                  <a class="info second me-2" (click)="openInfo2(i, j, k)">
                                    <fa-icon id="firstLevelIcon-{{j}}" class="faInfoCircle second"
                                    [ngClass]="{'active': expanded[i + 1][j + 1][k + 1]}" [icon]="faInfoCircle"></fa-icon>
                                  </a>
                                </div>
                              }
                              @if (secondLevel.riskDescription) {
                                <div class="info-content second px-3" [ngClass]="{'expand': expanded[i + 1][j + 1][k + 1]}"
                                  >
                                  <p class="m-0 pt-3 pb-3" [innerHTML]="secondLevel.riskDescription"></p>
                                </div>
                              }
                            </div>
                          }
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
              <button (click)="offerJunctureClick($event.currentTarget)" type="button" class="btn btn-light" data-bs-toggle="collapse"
                [attr.data-bs-target]="'#collapse' + option.contractGroupId" [attr.aria-controls]="'collapse' + option.contractGroupId">
                @if (!option.active) {
                  <span>{{ 'common.ok' | translate }}</span>
                }
                @if (option.active) {
                  <span><fa-icon class="faAngleLeft me-2" [icon]="faAngleLeft"></fa-icon>{{ 'junctures.offer.change' | translate }}</span>
                }
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
